import { createI18n } from 'vue-i18n';

// Import translation files
import en from './locales/en.json';
import th from './locales/th.json';

// Define messages
const messages = {
  en,
  th
};

// Default language
const systemSettings = localStorage.getItem('systemSettings');
let DEFAULT_LOCALE = 'en';
if (systemSettings) {
  try {
    const parsed = JSON.parse(systemSettings);
    if (parsed && parsed.i18nLng && parsed.i18nLng.code) {
      DEFAULT_LOCALE = parsed.i18nLng.code;
    }
  } catch (e) {
    DEFAULT_LOCALE = 'en';
  }
}

const DEFAULT_FALLBACK_LOCALE = 'en';

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Required for Vue 3, to enable the Composition API mode for vue-i18n
  locale: DEFAULT_LOCALE, // Default language
  fallbackLocale: DEFAULT_FALLBACK_LOCALE, // Fallback if translation is missing
  messages // Load messages from files
});

export default i18n;